import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, TrendingDown } from 'lucide-react';

const StatCard = ({ 
  title, 
  value, 
  icon: Icon, 
  trend, 
  bgColor = 'bg-gradient-to-br from-slate-50 to-slate-100',
  prefix = '',
  suffix = ''
}) => {
  const isPositive = trend >= 0;

  return (
    <motion.div
      whileHover={{ y: -4, boxShadow: '0 20px 40px rgba(0,0,0,0.08)' }}
      className={`${bgColor} rounded-2xl p-4 sm:p-6 border border-gray-100/60 shadow-sm transition-all duration-300`}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          <p className="text-gray-600 text-xs sm:text-sm font-medium mb-1 sm:mb-2 truncate">{title}</p>
          <div className="flex flex-wrap items-baseline gap-1.5 sm:gap-2">
            <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 truncate max-w-full">
              {prefix}{value}{suffix}
            </h3>
            {trend !== undefined && (
              <div className={`flex items-center gap-0.5 sm:gap-1 text-[11px] sm:text-xs font-semibold ${isPositive ? 'text-green-700' : 'text-red-700'}`}>
                {isPositive ? <TrendingUp size={13} /> : <TrendingDown size={13} />}
                {Math.abs(trend)}%
              </div>
            )}
          </div>
        </div>
        <div className="bg-white/60 rounded-xl p-2.5 sm:p-3 backdrop-blur-sm flex-shrink-0">
          <Icon size={20} className="text-gray-700 sm:w-6 sm:h-6" />
        </div>
      </div>
    </motion.div>
  );
};

export default StatCard;
